module.exports = "<template> <span class=tyl-open-icon part=root> <tcw-icon></tcw-icon> </span> </template>";